export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-m@2x.89fe7e50.webp";